<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import { resolveContactOrigin } from 'dashboard/helper/lais/originHelpers';

const props = defineProps({
  show: { type: Boolean, default: false },
  contact: { type: Object, default: () => ({}) },
  channelType: { type: String, default: '' },
});

const emit = defineEmits(['close']);

const origin = computed(() =>
  resolveContactOrigin(props.contact, props.channelType)
);

const formatDate = value => {
  if (!value) return '';
  const parsed = new Date(
    Number(value) < 1_000_000_000_000 ? Number(value) * 1000 : value
  );
  return Number.isNaN(parsed.getTime())
    ? String(value)
    : parsed.toLocaleDateString('pt-BR');
};

const rows = computed(() =>
  [
    {
      label: 'Canal',
      value: origin.value.canalLabel,
      icon: origin.value.canalIcon,
      helper: origin.value.inferred ? 'Inferido pelo inbox' : '',
    },
    { label: 'Mídia', value: origin.value.midia, icon: 'i-ph-megaphone' },
    { label: 'Campanha', value: origin.value.campanha, icon: 'i-ph-flag' },
    { label: 'Origem', value: origin.value.origem, icon: 'i-ph-tag' },
    {
      label: 'Primeiro contato',
      value: formatDate(origin.value.firstTouch),
      icon: 'i-ph-calendar',
    },
    {
      label: 'Modalidade de contato',
      value: origin.value.canalLabel,
      icon: origin.value.canalIcon,
    },
  ].filter(row => row.value)
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisModal
    :show="show"
    title="Origem do cliente"
    max-width-class="max-w-[520px]"
    @close="emit('close')"
  >
    <div v-if="rows.length" class="space-y-3">
      <div
        v-for="row in rows"
        :key="row.label"
        class="flex items-start gap-3 rounded-lais border border-lais-border bg-lais-background-soft p-3"
      >
        <span
          class="mt-0.5 size-4 shrink-0 text-lais-primary"
          :class="row.icon"
          aria-hidden="true"
        />
        <div class="min-w-0">
          <p
            class="text-[11px] font-semibold uppercase tracking-wide text-lais-text-muted"
          >
            {{ row.label }}
          </p>
          <p class="break-words text-sm font-semibold text-lais-text">
            {{ row.value }}
          </p>
          <p v-if="row.helper" class="mt-0.5 text-xs text-lais-text-muted">
            {{ row.helper }}
          </p>
        </div>
      </div>
    </div>
    <div v-else class="py-8 text-center">
      <span class="i-ph-tag size-8 text-lais-text-muted" aria-hidden="true" />
      <p class="mt-3 text-sm font-semibold text-lais-text">
        Origem não rastreada para este cliente.
      </p>
      <p class="mt-1 text-xs text-lais-text-muted">
        A origem aparece quando é capturada na criação do contato.
      </p>
    </div>

    <template #footer>
      <div class="flex justify-end">
        <button
          type="button"
          class="h-10 rounded-lais border border-lais-border px-4 text-sm font-semibold text-lais-text-body hover:bg-lais-primary-50"
          @click="emit('close')"
        >
          Fechar
        </button>
      </div>
    </template>
  </LaisModal>
</template>
